// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.card-step[data-v-4c31b88e]{\n  width: 130px;\n  flex-shrink: 0;\n}\n.text-xs[data-v-4c31b88e]{\n  font-size: 11px!important;\n}\n.text-value[data-v-4c31b88e]{\n  font-weight: 600;\n  color:#000;\n  font-size: 18px;\n}\n.container-cards[data-v-4c31b88e]{\n  gap: 18px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
